export const Wordmark = ({ dark = false }) => (
  <span className={`font-display inline-flex items-center gap-2 text-2xl tracking-[0.14em] ${dark ? "text-[#F3F7F5]" : "text-[#202622]"}`}>
    <svg width="30" height="22" viewBox="0 0 36 24" aria-hidden="true">
      <path d="M1 21 13.5 3 23 15.5 27 10.5 35 21 29.5 18.5 27 15.5 23 21 13.5 9 6 21Z" fill={dark ? "#8BE8C7" : "#3F8F68"} />
    </svg>
    AKTUA
  </span>
);

export const TopoLines = ({ className = "", opacity = 0.5 }) => (
  <svg className={className} width="420" height="300" viewBox="0 0 420 300" fill="none" aria-hidden="true" style={{ opacity }}>
    {[
      "M-20 250 C60 210 120 260 200 225 S340 190 440 230",
      "M-20 210 C70 170 130 220 210 185 S350 150 440 190",
      "M-20 170 C80 130 140 180 220 145 S360 110 440 150",
      "M-20 130 C90 90 150 140 230 105 S370 70 440 110",
      "M-20 90 C100 50 160 100 240 65 S380 30 440 70",
    ].map((path, index) => <path key={index} d={path} stroke="currentColor" strokeWidth="1.2" />)}
    <path d="M40 265 C110 240 180 250 260 220 S380 185 430 205" stroke="currentColor" strokeWidth="2.4" strokeDasharray="1 7" strokeLinecap="round" />
  </svg>
);
